import { ListItem } from '../ListItem';

export class ChatMessageSenderType {


  static List(): ListItem[]  {

    let list: ListItem[] = [
      { "id": 0, "name": "Unknown" },
      { "id": 1, "name": "Patient" },
      { "id": 2, "name": "Center" },
      { "id": 3, "name": "Doctor" }
    ];

    return list;
  }

  static Name(id: number): string {

    let rtn: string = "";

    ChatMessageSenderType.List().forEach(obj => {

      if (obj.id == id) {
        rtn = obj.name;
      }

    });

    return rtn;

  }


  static Value(name: string): number {

    let rtn: number = 0;

    ChatMessageSenderType.List().forEach(obj => {

      if (obj.name == name) {
        rtn = obj.id;
      }

    });

    return rtn;

  } 

}

